import { publicIdDecoded } from '@/services/api/resources/public-ids/codec';
import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedGetRequest,
  decode,
  fetchApi,
} from '@/services/api';
import { chain } from 'fp-ts/TaskEither';

const baseUrl = (id: string) => `/v2/public-ids/${id}/decode`;

export const decodePublicId = (encodedId: string) => pipe(
  baseUrl(encodedId),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(publicIdDecoded)),
);
